module.exports = __webpack_public_path__ + "fonts/effect-science-research-390788.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-science-research.svg
// module id = 821
// module chunks = 0